/**
 * Clinical → eTMF intake (`/solutions/clinical/etmf-intake`).
 *
 * The results of the pipelines that classify, check and upload incoming study
 * documents to Veeva eTMF — for everyone, without the canvas. A Developer
 * publishes a pipeline here from its canvas ("Show results in → eTMF intake",
 * ADR-0032); this page is the shared results dashboard pointed at that page id.
 */

import { PipelineResultsDashboard } from "@/features/solutions/shared/pipeline-results";

export function EtmfIntakePage() {
  return (
    <PipelineResultsDashboard
      solutionPage="etmf_intake"
      title="eTMF intake"
      description="Incoming study documents, checked and uploaded to Veeva eTMF — what happened to each one."
    />
  );
}
